//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';
import { useSelector } from 'react-redux';

import { ContentDrawerDialog } from '@content-drawer/ContentDrawerDialog';
import { ContentImportOptions } from '@content-drawer/ContentImportOptions';
import { getIsDropboxImportsEnabled } from '@content-drawer/redux/getContentDrawer';
import { getIsContentDrawerEnabled } from '@content-drawer/selectors/getContentDrawerSettings';
import { UploadContextProvider } from '@content-drawer/upload/UploadContextProvider';
import { getIsMediaLibraryPageEnabled } from '@media-library/redux/getMediaLibraryPage';
import makeAngularReactController from '@react-bridge/angular-react-widget';

/**
    a. is content drawer enabled = true
      - dropbox feature flag enabled - render new content-drawer-trigger
      - dropbox feature flag disabled - render new content-drawer-trigger
    b. is content drawer enabled = false
      - dropbox feature flag enabled - render new content-drawer-trigger and show the dropdown
      - dropbox feature flag disabled - render new content-drawer-trigger and open old upload flow
 */
const ContentDrawerTrigger = () => {
  const isContentDrawerEnabled = useSelector(getIsContentDrawerEnabled);
  const isDropboxImportsEnabled = useSelector(getIsDropboxImportsEnabled);
  const isMediaLibraryPageEnabled = useSelector(getIsMediaLibraryPageEnabled);

  if (!isDropboxImportsEnabled && !isMediaLibraryPageEnabled) {
    return <></>;
  }

  return (
    <UploadContextProvider>
      {isContentDrawerEnabled ? (
        <ContentDrawerDialog />
      ) : (
        <ContentImportOptions triggerType='content-drawer-trigger' />
      )}
    </UploadContextProvider>
  );
};

angular.module('curalate').component('headerContentDrawerTrigger', {
  controller: makeAngularReactController(<ContentDrawerTrigger />),
});
